module.exports = __webpack_public_path__ + "img/about_us1.8cf0abe6.png";